;(function() {
  'use strict'

  angular.module('core.interactionGraph', [])
})()
